// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-color-primary: #3880ff;
  --ion-color-primary-rgb: 56,128,255;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255,255,255;
  --ion-color-primary-shade: #3171e0;
  --ion-color-primary-tint: #4c8dff;
  --ion-color-secondary: #5260ff;
  --ion-color-secondary-rgb: 82,96,255;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255,255,255;
  --ion-color-secondary-shade: #4854e0;
  --ion-color-secondary-tint: #6370ff;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82,96,255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255,255,255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #2dd36f;
  --ion-color-success-rgb: 45,211,111;
  --ion-color-success-contrast: #000000;
  --ion-color-success-contrast-rgb: 0,0,0;
  --ion-color-success-shade: #28ba62;
  --ion-color-success-tint: #42d77d;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255,196,9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0,0,0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb: 235,68,90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255,255,255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb: 146,148,156;
  --ion-color-medium-contrast: #000000;
  --ion-color-medium-contrast-rgb: 0,0,0;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #ffffff;
  --ion-color-light-rgb: 255,255,255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0,0,0;
  --ion-color-light-shade: #e0e0e0;
  --ion-color-light-tint: #ffffff;
}

/* Adjust the width as needed */
.custom-popover {
  --width: 300px; /* Set the desired width here */
}

.popover-container {
  width: 300px; /* Adjust the width value to fit your needs */
}

.custom-popover .popover-content {
  width: 300px;
}

.titleicon {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACC,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,6CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,8BAAA;EACA,oCAAA;EACA,uCAAA;EACA,+CAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,mCAAA;EACA,sCAAA;EACA,8CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,kCAAA;EACA,qCAAA;EACA,uCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,kCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gCAAA;EACA,+BAAA;AAND;;AAUA,+BAAA;AACA;EACI,cAAA,EAAA,+BAAA;AAPJ;;AAUE;EACE,YAAA,EAAA,6CAAA;AAPJ;;AAUE;EACD,YAAA;AAPD;;AAUE;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;AAPJ","sourcesContent":[":root {\n\t--ion-color-primary: #3880ff;\n\t--ion-color-primary-rgb: 56,128,255;\n\t--ion-color-primary-contrast: #ffffff;\n\t--ion-color-primary-contrast-rgb: 255,255,255;\n\t--ion-color-primary-shade: #3171e0;\n\t--ion-color-primary-tint: #4c8dff;\n\n\t--ion-color-secondary: #5260ff;\n\t--ion-color-secondary-rgb: 82,96,255;\n\t--ion-color-secondary-contrast: #ffffff;\n\t--ion-color-secondary-contrast-rgb: 255,255,255;\n\t--ion-color-secondary-shade: #4854e0;\n\t--ion-color-secondary-tint: #6370ff;\n\n\t--ion-color-tertiary: #5260ff;\n\t--ion-color-tertiary-rgb: 82,96,255;\n\t--ion-color-tertiary-contrast: #ffffff;\n\t--ion-color-tertiary-contrast-rgb: 255,255,255;\n\t--ion-color-tertiary-shade: #4854e0;\n\t--ion-color-tertiary-tint: #6370ff;\n\n\t--ion-color-success: #2dd36f;\n\t--ion-color-success-rgb: 45,211,111;\n\t--ion-color-success-contrast: #000000;\n\t--ion-color-success-contrast-rgb: 0,0,0;\n\t--ion-color-success-shade: #28ba62;\n\t--ion-color-success-tint: #42d77d;\n\n\t--ion-color-warning: #ffc409;\n\t--ion-color-warning-rgb: 255,196,9;\n\t--ion-color-warning-contrast: #000000;\n\t--ion-color-warning-contrast-rgb: 0,0,0;\n\t--ion-color-warning-shade: #e0ac08;\n\t--ion-color-warning-tint: #ffca22;\n\n\t--ion-color-danger: #eb445a;\n\t--ion-color-danger-rgb: 235,68,90;\n\t--ion-color-danger-contrast: #ffffff;\n\t--ion-color-danger-contrast-rgb: 255,255,255;\n\t--ion-color-danger-shade: #cf3c4f;\n\t--ion-color-danger-tint: #ed576b;\n\n\t--ion-color-medium: #92949c;\n\t--ion-color-medium-rgb: 146,148,156;\n\t--ion-color-medium-contrast: #000000;\n\t--ion-color-medium-contrast-rgb: 0,0,0;\n\t--ion-color-medium-shade: #808289;\n\t--ion-color-medium-tint: #9d9fa6;\n\n\t--ion-color-light: #ffffff;\n\t--ion-color-light-rgb: 255,255,255;\n\t--ion-color-light-contrast: #000000;\n\t--ion-color-light-contrast-rgb: 0,0,0;\n\t--ion-color-light-shade: #e0e0e0;\n\t--ion-color-light-tint: #ffffff;\n\n}\n\n/* Adjust the width as needed */\n.custom-popover {\n    --width: 300px; /* Set the desired width here */\n  }\n  \n  .popover-container {\n    width: 300px; /* Adjust the width value to fit your needs */\n  }\n\n  .custom-popover .popover-content {\n\twidth: 300px;\n  }\n\n  .titleicon {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    text-align:center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
